import { ai as AiGen } from '@valvur/shared-grpc';

/** Topics for the current kid/neutral scope. */
export function topicsForKid(
  topics: AiGen.TopicThreadDto[],
  kidId: string | null,
): AiGen.TopicThreadDto[] {
  if (!kidId) {
    return topics.filter((t) => !t.kidId?.trim());
  }
  return topics.filter((t) => t.kidId === kidId);
}

/**
 * Ensures topicId matches kid/neutral scope before POST /conversation.
 * Pass scope-filtered topics (see ParentAiService.topics()) — if the selected
 * topic is not in that list, it is dropped (e.g. stale kid thread after switching
 * to general parenting).
 */
export function resolveSendScope(
  kidId: string | null,
  topicId: string | null,
  scopedTopics: readonly AiGen.TopicThreadDto[],
): { kidId: string; topicId: string } {
  const trimmedTopicId = topicId?.trim() || null;
  const scopedTopicId =
    trimmedTopicId &&
    scopedTopics.some((t) => t.id === trimmedTopicId)
      ? trimmedTopicId
      : null;
  return {
    kidId: kidId ?? '',
    topicId: scopedTopicId ?? '',
  };
}
